define('lq/events/actions/azureAICommand',[
    'lq/events/actions/eventAction',
    'lq/chatHub',
    'uuid'
], function(EventAction, chatHub, uuid) {
    'use strict';

    function AzureAICommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        this.groupId = uuid();
        return this;
    };

    EventAction.extend(AzureAICommand, EventAction);

    AzureAICommand.typeName = 'AzureAICommand';

    AzureAICommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    AzureAICommand.prototype.createEventActionRequest = function () {
        var self = this;

        if (this.shouldListenForStream()) {
            chatHub.startListeningAndSubscribe('ChatGPTStream', function (message) { // afe todo: maybe replace the ChatGPTStream?
                if(self.eventIsEnabled('streaming')) {
                    self.fullMessage = (self.fullMessage || '') + message;
                    self.triggerEvent('streaming', undefined, self.fullMessage);
                }
                self.triggerEventIfEnabled('streamingSection', undefined, message);
            }, { groupId: self.groupId });
        }
            

        return {
            eventActionType: 'AzureAI',
            command: this.eventData.command,
            groupId: this.groupId
        };
    };

    AzureAICommand.prototype.execute = function (continuation, eventActionResponse) {
        if (this.shouldListenForStream())
            chatHub.stopListeningAndUnsubscribe('ChatGPTStream', { groupId: this.groupId });
        continuation();
    };

    AzureAICommand.prototype.shouldListenForStream = function () {
        return this.eventData.eventing &&
            (
                (this.eventData.eventing['streaming'] &&
                    this.eventData.eventing['streaming'].enabled) ||

                (this.eventData.eventing['streamingSection'] &&
                    this.eventData.eventing['streamingSection'].enabled)
            );
    };

    return AzureAICommand;
});
